<template>
    <div class="section">
        <div class="container-fluid">
            <div class="section">
                <app-loader :loading="getLoaderStatus" :color="loadingOptions.color" :size="loadingOptions.size"></app-loader>
                <div class="container " v-if="!getLoaderStatus">
                    <div class="columns">
                        <div class="column is-5-desktop">
                            <h1 class="title has-text-centered">Edit Transaction</h1>
                            <transition name="fade">
                                <div v-if="alertMessage" class="alert-message is-success has-text-centered">
                                    {{ alertMessage }}
                                </div>
                            </transition>
                            <form>
                                <div class="field select-client-field">
                                    <div class="control">
                                        <model-select :options="options"
                                                      v-model="user"
                                                      :isDisabled="true"
                                                      class="input"
                                                      placeholder="Select Client">
                                        </model-select>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <input v-model="amount"
                                               v-bind:class=""
                                               class="input"
                                               type="number"
                                               placeholder="Amount"
                                               required=""
                                               autofocus="">
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <datetime
                                                input-class="input"
                                                v-model="transactionDate"
                                                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                                type="date"
                                                value-zone="local"
                                                zone="local"
                                                placeholder="Select date"
                                        ></datetime>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <textarea v-model="description" class="textarea"
                                                  placeholder="Description"></textarea>
                                    </div>
                                </div>

                                <div class="field">
                                    <div class="control text-center">
                                        <a v-if="amount - getAmountUsed >= 0" @click.prevent="editTransaction" class="button is-primary">Submit</a>
                                        <router-link tag="button" to="/banking" class="button is-danger"><span>Cancel</span>
                                        </router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="column is-offset-2-desktop">
                            <div v-if="amount - getAmountUsed < 0" class="error-alert">&nbsp;
                                The amount entered for individual invoice(s) exceeds the total payment the customer has made. Please check and retry.
                            </div>
                            <h1 v-else class="title has-text-centered">&nbsp;</h1>
                            <div class="client-amount-table-container">
                                <div class="card">
                                    <div class="card-content">
                                        <table class="table table-striped client-amount-table">
                                            <tr>
                                                <th colspan="5" class="">Deposits</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.deposit | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Receivables</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.receivables | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount received</th>
                                                <th>{{ getCurrency }}{{ amount | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount used for payments</th>
                                                <th>{{ getCurrency }}{{ getAmountUsed | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount in Excess</th>
                                                <th>{{ getCurrency }}{{ amount - getAmountUsed |
                                                    formatNumber }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount refunded</th>
                                                <th>{{ getCurrency }}{{ getTransactionRefundAmount | formatNumber }}</th>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="invoice-heading">
                                <h1 class="title has-text-centered">Unpaid Invoices</h1>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Chassis</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Due Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Used Amount</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <edit-unpaid-invoice-table-row v-for="(invoice, index) in unpaidInvoices"
                                                                   :invoice="invoice" :action="'edit'" :transactionTotals="transactionTotals"></edit-unpaid-invoice-table-row>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="column" v-if="false">
                            <div class="invoice-heading">
                                <h1 class="title has-text-centered">Unpaid Multi Invoices</h1>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Due Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Paid Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Deposit</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <unpaid-multi-invoice-table-row v-for="(invoice, index) in unpaidMultiInvoices"
                                                                :invoice="invoice" :action="'edit'" :transactionTotals="transactionTotals"></unpaid-multi-invoice-table-row>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import appLoader from 'vue-spinner/src/ClipLoader'
    import {ModelSelect} from 'vue-search-select'
    import apiUsers from './../../api/apiUsers'
    import {Datetime} from 'vue-datetime'
    import UnpaidInvoiceTableRow from "./UnpaidInvoiceTableRow";
    import apiProformaInvoices from "../../api/apiProformaInvoices";
    import UnpaidMultiInvoiceTableRow from "./UnpaidMultiInvoiceTableRow";
    import EditUnpaidInvoiceTableRow from "./EditUnpaidInvoiceTableRow";

    export default {
        components: {
            EditUnpaidInvoiceTableRow,
            UnpaidMultiInvoiceTableRow,
            UnpaidInvoiceTableRow,
            ModelSelect,
            Datetime,
            appLoader
        },
        data() {
            return {
                options: [],
                loadingOptions: this.$store.getters.getOptions,
                countries: [],
                professional: false,
                roles: [
                    'Visitor',
                    'User',
                    'Manager',
                    'Affiliate',
                    'Admin'
                ],
                isProfessional: false,
            }
        },
        computed: {
            success: function () {
                return this.$store.getters.getNewCarSuccessStatus
            },
            isLoading: function () {
                return this.$store.getters.getNewCarLoadingStatus
            },
            userId: function () {
                return this.$store.getters.getNewCarUser
            },
            alertMessage: function () {
                return this.$store.getters.getTransactionStatus
            },
            transactionTotals: function () {
                return this.$store.getters.getTransactionTotals
            },
            amount: {
                get() {
                    return this.$store.getters.getTransactionAmount;
                },
                set(value) {
                    this.$store.commit('setTransactionAmount', value)
                }
            },
            user: {
                get() {
                    return this.$store.getters.getTransactionClient;
                },
                set(value) {
                    this.$store.commit('setTransactionClient', value)
                }
            },
            type: function () {

                    return this.$store.getters.getTransactionType;
            },
            transactionDate: {
                get() {
                    return this.$store.getters.getTransactionDate
                },
                set(value) {
                    this.$store.commit('setTransactionDate', value)
                }
            },
            description: {
                get() {
                    return this.$store.getters.getTransactionDescription;
                },
                set(value) {
                    this.$store.commit('setTransactionDescription', value)
                }
            },
            unpaidInvoices() {
                return this.$store.getters.getUnpaidInvoices.invoices;
            },
            unpaidMultiInvoices() {
                return this.$store.getters.getUnpaidInvoices.multi_invoices;
            },
            getCurrency: function () {
                return this.$store.getters.getTransactionTotals.currency == 2 ? '$' : '¥'
            },
            getAmountUsed: function () {
                let invoiceAmountUsed = this.$store.getters.getInvoiceAmountUsed
                let used_amount = 0;
                invoiceAmountUsed.forEach((invObj) => {
                    used_amount += Number(invObj.amount_used)
                })

                return used_amount
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            getTransactionRefundAmount() {
                return this.$store.getters.getTransactionRefundAmount
            }
        },
        methods: {
            getInvoices() {
                apiProformaInvoices
                    .requestUnpaidInvoices(this.user)
                    .then((response) => {
                        this.$store.commit('setUnpaidInvoices', response.data)
                        response.data.invoices.forEach((invoice) => {
                            this.$store.commit('setInvoiceAmountUsed', {'invoice_id': invoice.id, 'amount_used': invoice.used_amount, 'deposit': invoice.deposit_payment})
                        })

                    })
                this.$store.dispatch('getTransactionTotals', this.user)
            },
            onSelect(items, lastSelectItem) {
                this.user = items
                this.$store.commit('setTransactionClient', value)
            },
            setSelectOptions(users) {
                let list = []

                users.forEach(function (element) {
                    list.push({
                        value: element.id,
                        text: element.name
                    })
                })

                this.options = list
            },
            editTransaction() {
                let invoices = this.unpaidInvoices
                //let multiInvoices = this.unpaidMultiInvoices
                let data = {
                    client_id: this.user,
                    amount: this.amount,
                    type: this.type,
                    transaction_date: this.transactionDate,
                    description: this.description,
                    invoices: invoices,
                    //multi_invoices: multiInvoices
                }
                this.$store.dispatch('editBankingTransaction', {data: data, id: this.$route.params.id})
            },
            getTotalDueAmount() {
                let totalDue = 0;
                if(this.unpaidInvoices != undefined) {
                    this.unpaidInvoices.forEach((invoice, index) => {
                        if (invoice.currency == 2 && this.transactionTotals.currency != 2) {
                            totalDue += Math.round(invoice.balance_due * invoice.rate) - invoice.paid_amount;
                        } else {
                            totalDue += invoice.balance_due - invoice.paid_amount;
                        }
                    })
                }
                return totalDue;
            },
            getTotalPaidAmount() {
                let totalPaid = 0;
                if(this.unpaidInvoices != undefined) {
                    this.unpaidInvoices.forEach((invoice, index) => {
                        totalPaid = invoice.paid_amount;
                    });
                }
                return totalPaid;
            }
        },
        created() {
            this.$store.dispatch('getTransaction', this.$route.params.id)
            this.$store.commit('setTransactionStatus', '')


            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>

    .field.select-client-field .control {
        display: flex;
    }

    .field.select-client-field .control button.button.is-primary {
        margin-left: 10px;
        align-self: center;
    }

    .alert-message {
        margin-bottom: 10px;
    }

    table.table.client-amount-table {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banking/EditTransaction.vue